
















































import Vue from 'vue';
import { genVuexComputeds } from '@/main/pages/editFactory';
import { store } from '@/modules/servis/zakazka/store/edit';

import { SkupinaProfilSelect } from '../../components';
import ProvozovnaSelect from '../../components/microcomponents/ProvozovnaSelect.vue';
import SlevaMaterialNumberInput from '../../components/microcomponents/SlevaMaterialNumberInput.vue';
import SmluvniPartnerTypSelect from '../../components/microcomponents/SmluvniPartnerTypSelect.vue';
import SDA from '../../components/microcomponents/SDA.vue';
import JinyPrijemceSelect from '../../components/microcomponents/JinyPrijemceSelect.vue';
import SmluvniPartnerSelect from '../../components/microcomponents/SmluvniPartnerSelect.vue';
import SlevaInputNumber from '../../components/microcomponents/SlevaInputNumer.vue';

export default Vue.extend({
	name: 'HlavniKarta',
	components: {
		JinyPrijemceSelect,
		SmluvniPartnerTypSelect,
		sda: SDA,
		SlevaMaterialNumberInput,
		ProvozovnaSelect,
		SkupinaProfilSelect,
		SmluvniPartnerSelect,
		SlevaInputNumber,
	},
	props: {
		storeUri: {
			type: String,
			required: true,
		},
	},
	computed: {
		...genVuexComputeds(store),
		prevodMaxSuffix() {
			return ` (${this.PrevodMaxLimit ? this.PrevodMaxLimit : 0})`;
		},
	},
});
